import { getScrollTimeOfWeek, formatLabelDateEvent } from '../utils/fullcalendar'
import { convertOldDraft, patchDraft } from '../utils/draft.js';
import postsMixins from '@/components/dash/posts/mixins/main.js'

export default {
    vmixins: [postsMixins],
    methods: {
        prev() {
            console.log('clem43 prev',JSON.parse(JSON.stringify(this.eventsHistory)))
            this.eventsHistory.next = this.events
            if (this.eventsHistory.prev) {
                this.events = this.eventsHistory.prev
                this.eventsHistory.prev = null
                this.refreshEvents()
            }

            let calendarApi = this.$refs.fullCalendar.getApi()
            calendarApi.batchRendering(() => {
            
                calendarApi.prev()
                this.currentDate = calendarApi.getDate()
              
                this.$nextTick(()=>{
                    calendarApi.scrollToTime(getScrollTimeOfWeek(calendarApi, calendarApi.getEvents()))
                    calendarApi.render()
                    this.getPlannerData()
                })
            })
       
        },

        next() {
            console.log('clem43 next',JSON.parse(JSON.stringify(this.eventsHistory)))
            this.eventsHistory.prev = this.events
            if (this.eventsHistory.next) {
                this.events = this.eventsHistory.next
                this.eventsHistory.next = null
                this.refreshEvents()
            }
            
            let calendarApi = this.$refs.fullCalendar.getApi()
            calendarApi.batchRendering(() => {
                calendarApi.next()
                this.currentDate = calendarApi.getDate()

                this.$nextTick(()=>{
                    calendarApi.scrollToTime(getScrollTimeOfWeek(calendarApi, calendarApi.getEvents()))
                    calendarApi.render()
                    this.getPlannerData()
                })
            })
    
        },

        setDateFromDatePiker(e) {
            console.log("setDateFromDatePiker", e.target.value)
            this.eventsHistory.prev = null
            this.eventsHistory.next = null

            let date = new Date(e.target.value)
            this.currentDate = date
            this.eventsHistory.next = this.events

            let calendarApi = this.$refs.fullCalendar.getApi()
     
            calendarApi.batchRendering(() => {

                calendarApi.gotoDate(e.target.value); 

                this.$nextTick(()=>{
                    calendarApi.scrollToTime(getScrollTimeOfWeek(calendarApi, calendarApi.getEvents()))
                    calendarApi.render()
                    this.getPlannerData()
                })
            })
        },

        goToToday() {
            this.eventsHistory.prev = null
            this.eventsHistory.next = null

            let calendarApi = this.$refs.fullCalendar.getApi()
            calendarApi.batchRendering(() => {
                calendarApi.today()
                this.currentDate = calendarApi.getDate()
                this.getPlannerData(0)
            })
        },

        switchToMonth() {
            let calendarApi = this.$refs.fullCalendar.getApi()
     
            calendarApi.batchRendering(() => {
                const events = this.getEventsForMonth()
               
               
                if (events.length) {
                    calendarApi.setOption('events', events);
                }else{ 
                    calendarApi.removeAllEvents();
                    calendarApi.setOption('scrollTime', `09:00:00`);
                }
                this.currentViewType = 'dayGridMonth'
                localStorage.setItem('planner/currentViewType', 'dayGridMonth')
                calendarApi.changeView('dayGridMonth')
                this.$nextTick(()=>{
                    calendarApi.render()
                })
                this.currentDate = calendarApi.getDate()
            })
          
        },

        switchToWeek() {
       
            let calendarApi = this.$refs.fullCalendar.getApi()

            calendarApi.batchRendering(() => {
                const events = this.getEventsForWeek()

            
                if (events.length) {
                    calendarApi.setOption('events', events);
                }else{ 
                    calendarApi.removeAllEvents();
                }
            
                this.currentViewType = 'timeGridWeek'
                localStorage.setItem('planner/currentViewType', 'timeGridWeek')
                calendarApi.changeView('timeGridWeek')
                calendarApi.setOption('scrollTime', getScrollTimeOfWeek(calendarApi, events));
                this.$nextTick(()=>{
                    calendarApi.render()
                })
                this.currentDate = calendarApi.getDate()
                
            })
        },

        switchCurrentViewType() {
            this.eventsHistory.next = null
            this.eventsHistory.prev = null
            if (this.currentViewType === 'dayGridMonth') {
                this.switchToWeek()
            } else {
                this.switchToMonth()
            }
            this.getPlannerData(0)
        },

        handleDragStart(info) {
            this.eventIsDrag = true
            this.lastEventDraged = this.events[info.event.id]
        },
        
        handleDragStop(info) {
    
            this.eventIsDrag = false
            console.log('handleDragStop', info)
            this.$nextTick(()=>{
                const eventId = info.event.id
                let calendarApi = this.$refs.fullCalendar.getApi()
                let updatedEvent = calendarApi.getEventById(eventId);
                
                const event = this.lastEventDraged

                if (event) {
                    const newDate = updatedEvent.start
                    const lastDate =  new Date(event.date)
                     
                    if (Date.now() < newDate.getTime()) {
                        if (newDate.getTime() !== lastDate.getTime()) {

                            if (this.events[eventId]) this.events[updatedEvent.id].date = updatedEvent.start.toISOString()
                        
                            if (calendarApi.view.type == "timeGridWeek" && (!this.moreContentGridWeek.isOpen || info.event.start.getTime() !== updatedEvent.start.getTime())) {
                                this.refreshEvents()
                                
                            }
                            this.changeDatePost(eventId, updatedEvent.start)
                        }
                    }else{
                        this.refreshEvents()
                    }
                   
                }
            })
        },

        handleDateSelect(selectInfo) {
          
            let calendarApi = selectInfo.view.calendar

            let start = selectInfo.startStr
            let end = new Date(selectInfo.endStr)
            


            end.setDate(end.getDate() - 1)
            end = end.toISOString().split('T')[0]

            if (calendarApi.view.type == "dayGridMonth" && start !== end) {
                calendarApi.unselect()
                return
            }

            
            console.log('handleDateSelect')

            let currentDate = new Date()
            if (calendarApi.view.type == "dayGridMonth") {
                currentDate.setHours(0)
                currentDate.setMinutes(0)
                currentDate.setMilliseconds(0)
            }
            
            let scheduleDate = new Date(start)

            if (scheduleDate < currentDate) {
                console.log('currentDate < scheduleDate')
                calendarApi.unselect()
                return
            }

            if (calendarApi.view.type == "dayGridMonth") {
                if (currentDate.toISOString().split('T')[0] == start) {
                    scheduleDate = new Date(Date.now() + 1000 * 60 * 10)
                }else {
                    scheduleDate.setHours(9)
                }
            }

            this.$router.push({
                name: 'postCreator',
                query: { scheduleDate: scheduleDate.toISOString()}
            })
            return

            let status = prompt('Status du post')

            const date = start + (calendarApi.view.type == "dayGridMonth" ? 'T12:00:00' : '')
            
            const post = {
                "id": Math.random().toString(36).substr(2, 9),
                "date": date,
                "image": Math.floor(Math.random() * 5) === 0 ? null : `https://picsum.photos/20${Math.floor(Math.random() * 99)}`,
                "status": status && ['scheduled','posted','draft','pending','pending','echec','deleted','standby'].includes(status) ? status : ['scheduled','scheduled','scheduled','posted','posted','posted','draft','draft','pending','pending','echec','deleted','standby'][Math.floor(Math.random() * 13)],
                "page": this.allPages[Math.floor(Math.random() * this.allPages.length)],
                "content": "Le 14 septembre 2023, le parc sera le théâtre d'un pique-nique géant. Apportez vos paniers ! 🍉🍔 #PiqueNiqueEnFête",
                "type": ['image','video','reel','story','carousel', 'document'][Math.floor(Math.random() * 6)],
            }
    
            this.events[post.id] = post
     
            switch (calendarApi.view.type) {
                case "dayGridMonth":
                    calendarApi.batchRendering(() => {
                        calendarApi.unselect() // clear date selection
                        let event = {
                            id: post.id,
                            title: post.status,
                            extendedProps: {
                                image: post.image,
                                status: post.status,
                                page:post.page,
                                type:post.type
                            },
                            start: post.date,
                            end: post.date,
                            allDay: false
                        }
                        console.log('event',event)
                        calendarApi.addEvent(event)
                    })
                    break;
            
                case "timeGridWeek":
                    this.refreshEvents()
                    calendarApi.unselect()
                    break;
            }
        },

        async handleEventClick(clickInfo, fetchPost=true) {

            if (clickInfo.event.id.startsWith('more')) {
                this.clickMoreEvent(clickInfo)
            }else{
              
                //convert old draft
             
                if (this.events[clickInfo.event.id].draft && !this.events[clickInfo.event.id].draft.saveAllFormData) {
                    console.log("handleEventClick",this.events[clickInfo.event.id].draft)
                    const pages =  this.events[clickInfo.event.id].originalPost.page && this.events[clickInfo.event.id].originalPost.page[0].posts_multipages ? 
                        this.events[clickInfo.event.id].originalPost.page[0].posts_multipages.map(({page}) => page) : 
                        [this.events[clickInfo.event.id].page.id]

                    const draft = await convertOldDraft(JSON.parse(JSON.stringify(this.events[clickInfo.event.id].draft)), pages)
        
                    this.$set(this.events[clickInfo.event.id], 'draft', draft)
                    
                }

                patchDraft(this.events[clickInfo.event.id].draft)
                if (clickInfo.event.id.endsWith('_storification')) {
                    this.$set(this.events[clickInfo.event.id].draft, 'tab', "story_share")

                }else if (this.events[clickInfo.event.id].draft.tab == "story_share") {
                    this.$set(this.events[clickInfo.event.id].draft, 'tab', "standard")
                }


                this.eventIdSelected = clickInfo.event.id

                if (fetchPost) {
                    let body;
                    if (this.events[clickInfo.event.id].status == 'draft') {
                        const reponse = await this.findDraft(this.events[clickInfo.event.id].originalPost._bots[0].id, this.events[clickInfo.event.id].originalPost._id)
                        body = reponse.body
                    }else{
                        const reponse = await this.findPost(this.events[clickInfo.event.id].originalPost._bots[0].id, this.events[clickInfo.event.id].originalPost.id, this.events[clickInfo.event.id].originalPost.page[0].post_number)
                        body = reponse.body
                    }

                    const event = await this.buildEvent({
                        ...this.events[clickInfo.event.id].originalPost,
                        ...body.post
                    });

                    this.events[clickInfo.event.id] = event

                    this.handleEventClick(clickInfo, false) //pour convertir le draft
                }
            }
     
        },

        handleEvents(events) {
            /*
                déclanché pratiquement a chaque fois qu'une action est faire
            */
            console.log('handleEvents', events)
            this.currentEvents = events
        },

        refreshEvents() {
            console.log('refreshEvents')
            let calendarApi = this.$refs.fullCalendar.getApi()

            calendarApi.batchRendering(() => {
                const events = calendarApi.view.type == "dayGridMonth" ? this.getEventsForMonth() : this.getEventsForWeek()
                console.log('refreshEvents events',events)
                if (events.length) {
                    calendarApi.setOption('events', events);
                }else{ 
                    calendarApi.removeAllEvents();
                }

                if (calendarApi.view.type == "timeGridWeek" && (true || this.moreContentGridWeek.isOpen)) {
                    this.$nextTick(()=>{
                        this.test()
                    })
                } 
            })
        },

        recalculateResponsive() {
            this.$refs.fullCalendar.getApi().updateSize();
        },
        
        ///////////// function render content /////////////

        renderEventContent(eventInfo) {
            /*
                return le contenue d'un event
            */
            //https://fullcalendar.io/docs/content-injection
            const data = eventInfo.event.extendedProps;
            if (!eventInfo.event.id) return ''

            if (eventInfo.event.id.startsWith('more')) {

                if (eventInfo.event.id.startsWith('moreClose')) {
                    return {
                        html: `<div class="buttonMore viewAllEvent" index="${data.viewAllEvent ? data.index : ''}"><a>Fermer</a></div>`
                    }
                }else{
                    return {
                        html: `<div index="${data.index}" class="buttonMore"><a>${eventInfo.event.title}</a></div>`
                    }
                }
                
            }

            return {
                html: `<div index="${data.index}" class="post ${data.status} ${data.viewAllEvent ? 'viewAllEvent' :''} card-status-border-color card-status-background-color hover-card-status-background-color hover-card-status-border-color">
                        ${data.image ? `<div class="post-image ${data.type}">
                            <img src="${data.image}"/>
                            <div class="type-post ${data.type}"></div>
                        </div>` : ''}
                        <div class="container-info">
                            <div class="top">
                                <div class="badge-status ${data.loading && 'loading'}" status="${data.status}">
                                    ${'' && data.status} ${this.eventIsDrag || !data.dateLabel ? formatLabelDateEvent(eventInfo.event.start) : data.dateLabel}
                                </div>
                               
                                <div class="avatar ${data.page && data.page.network ? data.page.network : ''}">
                                    <img src="${data.page && data.page.avatar  ? data.page.avatar : 'img/avatar.jpg'}">
                                </div>
                            </div>
                            <div class="content">
                               <p>${eventInfo.event.title}</p>
                            </div>
                        </div>
                    </div>`,
            };
        },

        moreLinkContent(args) {
            /*
                return le contenu du button 'voir plus' pour chaque celulle si trop d'event
            */
            return `+ ${args.num}`
        },

        handleDayCellContent(info) {
            /* 
                return le contenu du header de chaque jour (view month) et 
                ajouter la classe "has-event" a la cellule si un evenement est trouvé
            */

            const dateString = info.date.toLocaleDateString('fr-FR', {  
                year: 'numeric',  
                month: '2-digit',  
                day: '2-digit'  
            }).split('/').reverse().join('-')

            let cell = document.querySelector(`td[data-date="${dateString}"]`);

            if (cell && cell.querySelector('.fc-event')) {
                cell.classList.add('has-events');
            }
            return info.dayNumberText
        },

        handlerEventClassNames(info) {

            if (info.view.type == "timeGridWeek" && info.event.extendedProps.viewAllEvent && info.event.extendedProps.index >= 0) {
                return `viewAllEvent ${info.event.id.startsWith('more') ? 'btn-more' : ''}`
            }
        },

        //////////////////////////////////////////////////

        handleDayCellDidMount(info) {
            console.log("handleDayCellDidMount", info)              
        },

        handlerEventDidMount(info) {
          
          /* 
              Déclenché juste apres qu'un événement soit ajouté au DOM
              ajouter la classe "has-event" a la celulle
          */
          const eventElement = info.el;

          switch (info.view.type) {
              case "timeGridWeek":
                //   console.log('handlerEventDidMount eventElement',info.event.id, eventElement,info.event.extendedProps.viewAllEvent)
                  if (info.event.extendedProps.viewAllEvent) {
                    eventElement.parentElement.classList.add('viewAllEvent')

                   
                    // if (info.event.extendedProps.index) {
                    //     eventElement.parentElement.classList.add('viewAllEvent'+info.event.extendedProps.index)
                    //     eventElement.parentElement.style.cssText = eventElement.parentElement.style.cssText + `z-index: ${ 999 + info.event.extendedProps.index} !important`
                    // }
                  }else{
                    if(info.event.id.startsWith('more')) {
                        eventElement.parentElement.style.cssText = eventElement.parentElement.style.cssText + `z-index: ${ 999999 } !important`
                    }
                  }

                  
                  break;
          
              case "dayGridMonth":
                  
                  const dayCell = eventElement.closest('.fc-daygrid-day');
                //   console.log("handlerEventDidMount",info,eventElement,dayCell)
                  if (dayCell) {
                      dayCell.classList.add('has-events');
                  }
                  break;
          }
      
        },

        handlerEventWillUnmount(info) {
            /* 
                Déclenché juste avant qu'un événement ne soit supprimé du DOM
                enleve la classe "has-event" a la celulle si plus d'event
            */
 
            const eventElement = info.el;
            const dayCell = eventElement.closest('.fc-daygrid-day');
            if (dayCell) {
                const remainingEvents = dayCell.querySelectorAll('.fc-event').length;
                if (remainingEvents == 1) {
                    dayCell.classList.remove('has-events');
                }
            }
        },
        
        getEventsForMonth(events = this.events) {
            let eventBuild, isSearchBarMatching;
            const eventsBuild =  Object.values(events).reduce((acc, event) => {
                isSearchBarMatching = !this.filter.search || (event.content && event.content.toLowerCase().includes(this.filter.search))
                if (this.filter.statusDisplay[event.status] && isSearchBarMatching && (!event.type || this.filter.typesDisplay[event.type])) {

                    eventBuild = {
                        "id": event.id,
                        "title": event.content,
                        "extendedProps": {
                            image: event.image,
                            status: event.status,
                            page: event.page,
                            dateLabel: formatLabelDateEvent(event.date),
                            type: event.type,
                            loading: event.loading
                        },
                        "start": event.date,
                        "end": new Date(new Date(event.date).getTime() + 1000),
                        "allDay": false,
                    }
                    console.log("getEventsForMonth",event.status)
                    if (['posted','removed'].includes(event.status)) {
                        eventBuild.editable= false // Empêche toute modification
                        eventBuild.eventStartEditable= false // Bloque le déplacement
                        eventBuild.durationEditable= false // Bloque le redimensionnement
                    }
                    acc.push(eventBuild)
                }

                return acc
            },[]) 
            console.log("getEventsForMonth", eventsBuild.length)
            return eventsBuild
        },

        getEventsForWeek(events = this.events) {
            console.log('getEventsForWeek posts',events)
            //return 5 avents max dans chaque heure et un 6eme avec l'id "more" si plus que 5
            let dateInstance, dayIndex, hours, minute, eventDateStr, eventsByHour, viewAllEvent
            let eventsBuild = []
            let sort = Array.from({ length: 7 }, () => ({}));

            Object.values(events).forEach((event)=>{
                if (this.filter.statusDisplay[event.status]) {
                    dateInstance = new Date(event.date)
                    dayIndex = dateInstance.getDay()
                    hours = dateInstance.getHours()
                    minute = dateInstance.getMinutes()
                    console.log('dayIndex',dayIndex,sort, event)
                    if (!sort[dayIndex][hours]) sort[dayIndex][hours] = {}
                    if (!sort[dayIndex][hours][minute]) sort[dayIndex][hours][minute] = []
                    sort[dayIndex][hours][minute].push(event)
                }
            })

            console.log('getEventsForWeek sort',sort)
            sort.forEach((dayData, indexDay)=>{
                Object.entries(dayData).forEach(([hour, hourData]) => {
                    eventsByHour = Object.values(hourData).flat()

                    viewAllEvent = this.moreContentGridWeek.isOpen && 
                        this.moreContentGridWeek.date instanceof Date && 
                        this.moreContentGridWeek.date.getDay() == indexDay &&
                        this.moreContentGridWeek.date.getHours() == hour
            

                    dateInstance = null

                    eventsByHour.slice(0,viewAllEvent ? eventsByHour.length : 6).forEach((event, index)=>{
                        if (!dateInstance) {
                            dateInstance = new Date(event.date)
                            dateInstance.setHours(dateInstance.getHours(), 0, 0, 0)
                        }else{
                            dateInstance = new Date(dateInstance.getTime() + 10 * 60 * 1000); // Ajoute 10 minutes
                        }
                      
                        eventDateStr = dateInstance.toISOString()
                           
                        const eventBuild = {
                            "id": event.id,
                            "title": event.content,
                            "extendedProps": {
                                image: event.image,
                                status: event.status,
                                page: event.page,
                                dateLabel: formatLabelDateEvent(event.date),
                                viewAllEvent: viewAllEvent,
                                type: event.type,
                                index: parseInt(dateInstance.getTime().toString().slice(0, -5)),
                                loading: event.loading
                            },
                            "start": eventDateStr,
                            "end": eventDateStr,
                            "allDay": false
                        }

                        if (['posted','removed'].includes(event.status)) {
                            event.editable= false // Empêche toute modification
                            eventBuild.eventStartEditable= false // Bloque le déplacement
                            eventBuild.durationEditable= false // Bloque le redimensionnement
                        }
                      

                        eventsBuild.push(eventBuild)
                    })
   
                    if (viewAllEvent && dateInstance) { 
                        dateInstance = new Date(dateInstance.getTime() + 10 * 60 * 1000); // Ajoute 10 minutes
                        eventDateStr = dateInstance.toISOString()
                        eventsBuild.push({
                            "id": `moreClose${indexDay}${hour}`,
                            "title": "",
                            "start": eventDateStr,
                            "end": eventDateStr,
                            "allDay": false,
                            "extendedProps": {
                                viewAllEvent: viewAllEvent,
                                index: eventsBuild[eventsBuild.length-1].extendedProps.index + 1,
                            },
                            durationEditable: false,
                            editable: false,           // Empêche toute modification
                            eventStartEditable: false, // Bloque le déplacement
                            durationEditable: false,   // Bloque le redimensionnement
                        })
                    }else if(eventsByHour.length > 6) {
                        eventsBuild[eventsBuild.length-1] = {
                            "id": `more${indexDay}${hour}`,
                            "title": "voir plus "+ (eventsByHour.length - 5),
                            "start": eventsBuild[eventsBuild.length-1].start,
                            "end": eventsBuild[eventsBuild.length-1].end,
                            "index": parseInt(new Date(eventsBuild[eventsBuild.length-1].start).getTime().toString().slice(0, -5)),
                            "allDay": false,
                            durationEditable: false,
                            editable: false,           // Empêche toute modification
                            eventStartEditable: false, // Bloque le déplacement
                            durationEditable: false,   // Bloque le redimensionnement
                        }
                    }

                    
                });
            })
            console.log('getEventsForWeek events',eventsBuild)
            return eventsBuild    
        },
        
        clickMoreEvent(clickInfo) {
            const calendarApi = this.$refs.fullCalendar.getApi();
            if (calendarApi.view.type !== "timeGridWeek") return
       
            console.log("clickMoreEvent",clickInfo)
            if (clickInfo.event.id.startsWith('moreClose')) {
                this.moreContentGridWeek.isOpen = false
                this.moreContentGridWeek.date = null
            }else{
                this.moreContentGridWeek.isOpen = true
                this.moreContentGridWeek.date = clickInfo.event.start
            }
            this.refreshEvents()
        },

        test() {
            console.log("test")
            console.log(this.$refs.fullCalendar.$el)
            let posts = this.$refs.fullCalendar.$el.querySelectorAll('.post , .buttonMore')
        
            let container, index

            posts.forEach(post => {
                index = post.getAttribute('index')
                if (index !== undefined) {
                    container = post.closest('.fc-timegrid-event-harness')
                    if (parseInt(index)%36 == 0) { //remplacer par un modulo 
                        console.log("test first-event")
                        const oldFirst = this.$refs.fullCalendar.$el.querySelector('.fc-timegrid-event-harness.first-event')
                        if (oldFirst) oldFirst.classList.remove('first-event')
                        container.classList.add('first-event')
                    }
                    container.style.cssText = container.style.cssText + `z-index: ${parseInt(index)} !important`
                    
                }
            });
        },
    },
  };